import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";
import {black, marketingMobileCuttoff, radiantBlue} from "@css/constants";

export const InfoBlockCallNowTextContainer = styled('div')(css`
  margin-top: 15px;
  margin-bottom: 25px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 15px;
    margin-bottom: 25px;
    margin-left: 25px;
  }
`)

export const phoneNumberBtnStyles = css`
  ${fontSize(19)};
  ${FontNormal(600)};
  text-decoration: underline;
`

export const InfoBlockCallNowTextHours = styled('p')(css`
  ${fontSize(15)};
  ${FontNormal(400)};
  color: ${black};
  padding-top: 5px;
`)

export const InfoBlockCallNowTextText = styled('p')(css`
  ${fontSize(14)};
  ${FontNormal(600)};
  color: ${black};
  font-style: italic;
  padding-top: 5px;
`)

export const InfoBlockCallNowTitle = styled('p')(css`
  ${fontSize(16)};
  ${FontNormal(600)};
  color: ${black};
  padding-top: 5px;
`)
